import axios from 'axios'
import moment from 'moment'

export const fetchInvoices = async ({page, search, per_page, filter, sort}) => {
    let currentPage = page || 1
    let perPage = per_page || 10
    let searchValue = search || ''
    let from = filter && filter.date_from && `&date_from=${moment(filter.date_from).format('DD.MM.YYYY')}`
    let to = filter && filter.date_to &&  `&date_to=${moment(filter.date_to).format('DD.MM.YYYY')}`
    let client = filter && filter.client
    let status = ''
    if(filter.status && filter.status.length > 0) {
        filter.status.forEach((item, index) => {
            status+= `&status[${index}]=${item.toLowerCase()}`
        })
    }
    let response
    try {
        response = await axios({
            method:'get',
            url:`/invoices?page=${currentPage}&sort=${sort.value}&direction=${sort.direction}&per_page=${perPage}${searchValue? `&search=${searchValue}` : ''}${from? from : ''}${to ? to : ''}${status}`
        })
        return response.data
    }catch(e) {
        console.log(e)
    }
}
export const exportToExcel = async ({search, filter}) => {
    return axios({
        method:'post',
        url:'/export',
        responseType: 'blob',
        data: {
            search,
            ...filter,
            date_from: filter.date_from && moment(filter.date_from).format('DD.MM.YYYY'),
            date_to: filter.date_to && moment(filter.date_to).format('DD.MM.YYYY'),
            status: filter.status && filter.status.map(item => item.toLowerCase())
        }
    })
}

export const fetchInvoice = async (id) => {
    let response = await axios({
        method:'get',
        url:`/invoices/${id}`
    })
    return response.data
}
export const createInvoice = (data) => {
    return axios({
        method:'post',
        url:'/invoices',
        data
    })
}